import React from "react";
import PageHero from "@/components/PageHero";
import ReviewsSection from "@/sections/ReviewsSection";
import FinalCTA from "@/sections/FinalCTA";
import GoogleRatingBadge from "@/components/GoogleRatingBadge";
import Seo from "@/components/Seo";
import { Star } from "lucide-react";
import { SITE } from "@/lib/site";

// Rating breakdown reflecting a 4.9 average across 251 reviews.
const breakdown = [
 { stars: 5, pct: 96, count: 237 },
 { stars: 4, pct: 3, count: 7 },
 { stars: 3, pct: 1, count: 2 },
 { stars: 2, pct: 0, count: 1 },
 { stars: 1, pct: 0, count: 0 },
];

const ReviewsHeroSlot = () => (
 <div className="relative">
 <div className="absolute -top-5 -right-5 w-32 h-32 rounded-full bg-[#FDD805] opacity-90 -z-0" aria-hidden />
 <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-2xl border-2 border-[#0F1115] -z-0" aria-hidden />
 <div className="relative bg-white border border-[#EAEAEA] rounded-3xl p-7 shadow-[0_10px_40px_rgba(0,0,0,0.05)] z-10">
 <div className="flex items-start justify-between gap-4">
 <div>
 <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[#4A4A4A]">
 Rating breakdown
 </div>
 <div className="mt-2 font-display font-black text-[48px] leading-none text-[#0F1115]">
 {SITE.googleRating.toFixed(1)}
 </div>
 <div className="mt-1 flex text-[#FDD805]">
 {[0, 1, 2, 3, 4].map((i) => (
 <Star key={i} size={14} fill="#FDD805" strokeWidth={0} />
 ))}
 </div>
 <div className="text-[11px] text-[#4A4A4A] uppercase tracking-[0.2em] font-bold mt-1">
 {SITE.googleReviewCount} reviews · Google
 </div>
 </div>
 </div>

 <div className="mt-5 space-y-2">
 {breakdown.map((row) => (
 <div key={row.stars} className="flex items-center gap-3 text-[12px]">
 <div className="w-4 font-bold text-[#0F1115]">{row.stars}</div>
 <Star size={11} fill="#FDD805" strokeWidth={0} className="text-[#FDD805] -ml-1" />
 <div className="flex-1 h-1.5 bg-[#F8F9FA] rounded-full overflow-hidden">
 <div
 className="h-full bg-[#FDD805] rounded-full"
 style={{ width: `${row.pct}%` }}
 />
 </div>
 <div className="w-10 text-right text-[#4A4A4A] tabular-nums">{row.pct}%</div>
 </div>
 ))}
 </div>
 </div>
 </div>
);

export default function ReviewsPage() {
 return (
 <div data-testid="page-reviews">
 <Seo
  title="Reviews: 4.9/5 on 251 Google Reviews"
  description="Real Google reviews of HG Corporates and HG Corporates from first-time founders. Averaging 4.9/5 across 251 verified reviews."
  path="/reviews"
  breadcrumbs={[
    { name: "Home", path: "/" },
    { name: "Reviews", path: "/reviews" },
  ]}
 />
 <PageHero
 eyebrow="Reviews"
 title="Founders speak we listen."
 subtitle={`${SITE.googleReviewCount} real Google reviews of ${SITE.parent} averaging ${SITE.googleRating.toFixed(1)} out of 5.`}
 rightSlot={<ReviewsHeroSlot />}
 />
 <section className="bg-white border-b border-[#EAEAEA]">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-10 flex flex-wrap items-center gap-6">
 <GoogleRatingBadge size="lg" testId="reviews-page-google-badge" />
 <div className="text-[12px] text-[#4A4A4A] uppercase tracking-[0.24em] font-bold max-w-md">
 {SITE.parent} · {SITE.addressShort}
 </div>
 </div>
 </section>
 <ReviewsSection />
 <FinalCTA />
 </div>
 );
}
